var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-filters"},_vm._l((_vm.items),function(item,index){return _c('button',{key:index,staticClass:"item",on:{"click":function($event){return _vm.clicked(item)}}},[_c('div',{staticClass:"square",class:{ selected: _vm.isSelected(item) }},[_c('i',{staticClass:"icon-check"})]),_c('span',[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }